<template>
  <ul class="menu-wrapper">
    <li v-for="(item, index) in filteredItems" :key="index" @click="emitClose">
      <NavItemSquare :item="item" />
    </li>
  </ul>
</template>

<script>
import NavItemSquare from './NavItemSquare'
import { mapGetters } from 'vuex'

export default {
  components: { NavItemSquare },
  computed: {
    ...mapGetters({
      abilities: 'user/definedAbilities',
    }),
    filteredItems() {
      return this.items.filter((item) => item.show)
    },
    items() {
      if (!(this.abilities && this.abilities.can)) return []

      return [
        {
          icon: 'human',
          title: 'Аккаунты',
          show: this.abilities.can('read', 'applications'),
          path: {
            name: 'applications',
          },
        },
        {
          icon: 'grading',
          title: 'Логи',
          count: this.$store.getters['logs/unsolved'],
          show: this.abilities.can('read', 'logs'),
          path: {
            name: 'logs',
          },
        },
        {
          icon: 'face',
          title: 'Сотрудники',
          show: this.abilities.can('read', 'managers'),
          path: {
            name: 'managers',
          },
        },
        {
          icon: 'dollar',
          title: 'Финансы',
          show: this.abilities.can('read', 'finances'),
          path: {
            name: 'finances',
          },
        },
        {
          icon: 'creditCard',
          title: 'Платежи',
          count: this.$store.getters['payments/unlinked'],
          show: this.abilities.can('read', 'payments'),
          path: {
            name: 'payments',
          },
        },
      ]
    },
  },
  methods: {
    emitClose() {
      this.$bus.$emit('close-menu')
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-wrapper {
  @include flex-grow(1);
}
</style>
